import { TChannel } from '@/types/common.ts';

const ENV = import.meta.env;
export const ACCOUNT_URL = ENV.VITE_ACCOUNT_URL as string;

export const PATHS = {
    index: '/',
    createPartner: '/partner-signup',
    profile: {
        root: '/profile',
        billing: '/profile/billing',
        members: '/profile/members'
    },
    contacts: '/contacts',
    sessions: '/sessions',
    session: '/session/:sessionId',
    history: '/history',
    dashboard: '/dashboard',
    attributes: '/attributes',
    settings: '/settings',
    widgets: '/widgets',
    auth: {
        login: {
            root: '/auth/login',
            callback: '/auth/login/callback'
        }
    }
};

export const DATE_FORMAT = {
    FULL_24H: 'YYYY-MM-DD HH:mm:ss',
    SHORT_24H: 'MM/DD HH:mm',
    FULL_12H: 'YYYY-MM-DD hh:mm:ss A',
    SHORT_12H: 'MM/DD/YYYY hh:mm A'
};

export const CHANNEL_TO_INTEGRATIONS = {
    sms: ['twilio_messenger/*'],
    chat: ['newo_chat/*', 'telegram/*'],
    phone: ['vapi/*', 'newo_voice/*']
};

export const INTEGRATION_TO_CHANNEL: Record<string, TChannel> = {
    newo_chat: 'chat',
    telegram: 'chat',
    twilio_messenger: 'sms',
    vapi: 'phone',
    newo_voice: 'phone'
};

export const TOOLTIP_PORTAL = 'tooltip-portal';
export const MENU_PORTAL = 'menu-portal';
export const POPOVER_PORTAL = 'popover-portal';
